// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__fl8iH"};